import ol = require("ol");
import Base = require("./base-command");
import Defaults = require("../models/defaults");
import Converter = require("../utils/ol3/converter");
import SymbologyUtils = require("../utils/symbology");
import Utils = require("../utils");

function layers(map: ol.Map) {
    let layers = map.getLayers().getArray()
        .filter(l => l instanceof ol.layer.Vector)
        .map(l => <ol.layer.Vector>l);
    return layers;
}

function asArray(value: any) {
    if (Array.isArray(value)) return value;
    return (value === undefined || value === null) ? [] : [value];
}

class Command extends Base<any> {

    static about = `
Renders a feature for one second then removes it from the map.

Usage Example:

    <EVENT about="Temporarily display geometry" event="flash-buffer" id="flash-buffer-handler" mid="app/commands/flash-feature">
    <OPTIONS>
        <Values about="wait one second before removing feature" id="delay" value="0" />
    </OPTIONS>
    </EVENT>

`;

    static options = {
        "box": {
            "about": "the rectangle  to hilite",
        },
        "delays": {
            "about": "time, in seconds, to show feature",
            "default": "1",
        },
        "extent": {
            "about": "the rectangle to hilite",
        },
        "feature": {
            "about": "the feature to hilite",
        },
    };

    static output = {
        "flash": {
            "about": "indicates if the feature should flash - true the first time and false when called after _delays_ seconds",
            "domain": "true|false",
        },
        "feature": {
            "about": "feature that was flashed",
        },
    }
    
    
    // current implementation only allows for 'box' and 'extent' but could be generalize to work with any geom    
    execute(args = this.args) {

        let options = this.asOptions(Command.options);

        let doit = () => {
            let originalInfo = <{
                feature: ol.Feature;
                handle: number;
            }>this.mediator.model.get("flash-feature");

            if (originalInfo) {
                clearTimeout(originalInfo.handle);
                this.mediator.model.set("flash-feature", null);
                originalInfo.feature.get("attributes")["selected"] = 0;
                originalInfo.feature.changed();
                this.trigger({
                    feature: originalInfo.feature,
                    flash: false
                });
            }
        };

        let isClustered = (source: ol.Feature, target: ol.Feature) => Array.isArray(source.get("features")) && -1 < source.get("features").indexOf(target);

        this.mediator.mapViewMap(map => {

            doit();

            // if we have a feature just adjust its style
            let feature = <Rhythm.GIS.FeatureQueryResultFeature>(this.findOption("feature") || this.findOption("activeFeature"));
            if (feature) {
                let olFeature = <ol.Feature>this.mediator.extend(feature).olFeature;
                if (olFeature) {
                    olFeature.get("attributes")["selected"] = 1;
                    olFeature.changed();

                    this.trigger({
                        feature: olFeature,
                        flash: true
                    });

                    this.mediator.model.set("flash-feature", {
                        feature: olFeature,
                        handle: ("0" !== options.delay) && setTimeout(doit, 1000 * parseFloat(options.delay))
                    });
                }

            }

        });
    }
}

export = Command; 